/// Auto-generated. Modifications will be overwritten.
/// Generated from core/overriden-document-schemas/CreditCardDocumentModel.yaml
/** Credit Card Document */
export class CreditCard {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return CreditCard.DOCUMENT_TYPE;
    }
    /** The card number of the recognized credit card */
    get cardNumber() {
        return this.document.fields.find((f) => f.type.name === 'CardNumber');
    }
    /** The cardholder name of the recognized credit card */
    get cardholderName() {
        return this.document.fields.find((f) => f.type.name === 'CardholderName');
    }
    /** The expiry date of the recognized credit card */
    get expiryDate() {
        return this.document.fields.find((f) => f.type.name === 'ExpiryDate');
    }
}
CreditCard.DOCUMENT_TYPE = 'CreditCard';
CreditCard.CARD_NUMBER_FIELD_NAME = 'CardNumber';
CreditCard.CARD_NUMBER_FIELD_NAME_NORMALIZED = 'CreditCard.CardNumber';
CreditCard.CARDHOLDER_NAME_FIELD_NAME = 'CardholderName';
CreditCard.CARDHOLDER_NAME_FIELD_NAME_NORMALIZED = 'CreditCard.CardholderName';
CreditCard.EXPIRY_DATE_FIELD_NAME = 'ExpiryDate';
CreditCard.EXPIRY_DATE_FIELD_NAME_NORMALIZED = 'CreditCard.ExpiryDate';
//# sourceMappingURL=CreditCardDocumentModel.js.map